import React, { useState } from 'react';
import style from "./FileInput.module.css";
import {s3Upload} from "../utils/s3Upload";
// import axios from "axios";

const FileInput = ({tab, handleInput, showFiles, getShowFiles}) => {
    const [isUploading, setIsUploading] = useState(false);

    // 이미지 상대경로 저장, Fetch로 파일 업로드
    const handleAddFile = async (event) => {
        event.preventDefault();
        const fileLists = Array.from(event.target.files);
        let fileListsArray = showFiles && [...showFiles];
        setIsUploading(true);
        for (let i = 0; i < fileLists.length; i++) {
            const sendResult = await s3Upload(fileLists[i])

            if (!sendResult || sendResult.result === 'fail') {
                setIsUploading(false);
                return alert("파일 업로드에 실패했습니다.");
            }

            else{
                fileLists[i].key = tab
                const downloadUrl = process.env.REACT_APP_FILE_URL + "/" +sendResult.savePath
                const newData = {key: `${fileLists[i].key}`, name: `${fileLists[i].name}`, url: downloadUrl}
                fileListsArray.push(newData);
                event.target.value = ''
            }
        }

        setIsUploading(false);
        getShowFiles(fileListsArray)
    };

    // X버튼 클릭 시 이미지 삭제
    const handleDeleteFile = (id,file) => {

        if(tab===file.key){
            const delFile = showFiles.filter((_, index) => index !== id)
             getShowFiles(delFile)
        }
    };

    return (

        <div className={style.item_input_file}>
            <label htmlFor="input-file" className={style.add_btn} onChange={handleAddFile}>
                <input type="file" id="input-file" multiple className={style.add_btn} name={`${tab}_file`} onChange={handleInput}/>
                <span>파일추가</span>
            </label>

            {isUploading && (
                <div className={style.loading_wrap}>
                    <div className={style.spinner}></div>
                    <span>업로드 중...</span>
                </div>
            )}

            {/* 저장해둔 이미지들을 순회하면서 화면에 이미지 출력 */}
            {showFiles?.map((file, id) => (
                <div className={style.container} key={id}>
                    {
                        file.key === tab &&
                        <>
                            <p className={style.file_name}><a target={'_blank'} href={file.url} rel="noreferrer">{file.name}</a></p>
                            <div className={style.delete_btn} onClick={() => handleDeleteFile(id,file)}>X</div>
                        </>

                    }
                </div>
            ))}
        </div>
    );
};

export default FileInput
